import * as React from 'react';
import classNames from 'classnames';

import { ChecklistEnum, OnboardingSteps } from './model';
import HelpArticleButton, {
  onContactSupport
} from '../../../utils/HelpArticleButton';
import { Button } from 'antd';
import HelpVideo from 'components/HelpVideo';
import * as translations from './strings';
import { getLangKey } from 'models/Language';
import styles from './index.module.css';
import BugHerdCreateTaskImg from './assets/bugherd_create_task.gif';

const strings = translations[getLangKey()];

const RightPanel = ({
  step,
  showEmbedJavascript
}: {
  step: ChecklistEnum;
  organizationId: number;
  userId: number;
  showEmbedJavascript: boolean;
  experiments: string[];
  elevioArticleId?: string;
}) => {
  const videoKey = OnboardingSteps[step].helpVideoKey;
  const hasHelpVideo: boolean = step !== ChecklistEnum.PERSONALIZE;
  const helpArticleId = OnboardingSteps[step].helpArticleId;
  const showConciergeHelp = ChecklistEnum.WEBSITE === step;

  const TalkToUs: React.FC = () => (
    <span className={styles.talkToUsOuter}>
      <p className={styles.videoInfo}>
        Watch this quick explainer ({OnboardingSteps[step].videoLength})
      </p>
      {strings.helpMessagePartOne}
      <a onClick={onContactSupport}>{strings.helpMessagePartTwo}</a>
    </span>
  );

  const getContentForRightPanel = () => {
    if (videoKey && hasHelpVideo) {
      return (
        <div className={styles.guideOuter}>
          <div className={styles.guideInfo}>
            {helpArticleId && <HelpArticleButton articleId={helpArticleId} />}
            <h3 className={styles.guideMessage}>
              {OnboardingSteps[step].guideMessage}
            </h3>
            <p>{OnboardingSteps[step].guideMessagePara}</p>
          </div>
          {showConciergeHelp ? (
            <ConciergeHelp />
          ) : (
            <>
              <HelpVideo videoKey={videoKey} />
              <TalkToUs />
            </>
          )}
        </div>
      );
    }

    return <TalkToUs />;
  };

  const ConciergeHelp: React.FC = () => (
    <div className={styles.conciergeHelp}>
      <img
        className={styles.createTaskImg}
        src={BugHerdCreateTaskImg}
        alt="Create a task with BugHerd"
      />

      <p>{strings.conciergeHelp1} </p>
      <Button
        onClick={() =>
          window.open('https://bugherd.typeform.com/to/wIfihfHy', '_blank')
        }
        type="link"
      >
        {strings.conciergeHelp2}
      </Button>
    </div>
  );

  return (
    <div
      className={classNames({
        [styles.rightPanelInner]: true,
        [styles.setupProjectRightPanel]: step === ChecklistEnum.SETUP_PROJECT,
        [styles.installExtensionRightPanel]:
          step === ChecklistEnum.INSTALL_BH && !showEmbedJavascript,
        [styles.installJavascriptRightPanel]:
          step === ChecklistEnum.INSTALL_BH && showEmbedJavascript,
        [styles.inviteRightPanel]: step === ChecklistEnum.PERSONALIZE,
        [styles.websiteRightPanel]: step === ChecklistEnum.WEBSITE
      })}
    >
      {getContentForRightPanel()}
    </div>
  );
};
export default RightPanel;
